(() => {
  const STORAGE_KEY = 'enjoiaWishlist';

  const getWishlist = () => {
    try {
      const stored = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (wishlist) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(wishlist)
    );

    updateWishlistUI();

    document.dispatchEvent(
      new CustomEvent('enjoia:wishlist-updated', {
        detail: {
          wishlist,
          count: wishlist.length
        }
      })
    );
  };

  const updateProductButton = (
    button,
    wishlist
  ) => {
    const handle =
      button.dataset.productHandle;

    const isFavorite = wishlist.some(
      item => item.handle === handle
    );

    button.classList.toggle(
      'is-favorite',
      isFavorite
    );

    button.setAttribute(
      'aria-pressed',
      isFavorite ? 'true' : 'false'
    );

    const title =
      button.dataset.productTitle || 'product';

    button.setAttribute(
      'aria-label',
      isFavorite
        ? `Verwijder ${title} uit favorieten`
        : `Voeg ${title} toe aan favorieten`
    );
  };

  const updateHeaderCount = (
    wishlist
  ) => {
    document
      .querySelectorAll(
        '[data-enjoia-wishlist-count]'
      )
      .forEach(counter => {
        const count = wishlist.length;

        counter.textContent = count;

        if (count > 0) {
          counter.hidden = false;
        } else {
          counter.hidden = true;
        }
      });
  };

  const updateWishlistUI = () => {
    const wishlist = getWishlist();

    document
      .querySelectorAll(
        '[data-enjoia-wishlist]'
      )
      .forEach(button => {
        updateProductButton(
          button,
          wishlist
        );
      });

    updateHeaderCount(wishlist);
  };

  document.addEventListener(
    'click',
    event => {
      const button =
        event.target.closest(
          '[data-enjoia-wishlist]'
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle =
        button.dataset.productHandle;

      const id =
        button.dataset.productId;

      const title =
        button.dataset.productTitle;

      const url =
        button.dataset.productUrl;

      let wishlist = getWishlist();

      const index =
        wishlist.findIndex(
          item =>
            item.handle === handle
        );

      if (index >= 0) {
        wishlist.splice(index, 1);
      } else {
        wishlist.push({
          id,
          handle,
          title,
          url
        });
      }

      saveWishlist(wishlist);

      button.classList.remove(
        'is-animating'
      );

      void button.offsetWidth;

      button.classList.add(
        'is-animating'
      );

      window.setTimeout(() => {
        button.classList.remove(
          'is-animating'
        );
      }, 350);
    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    updateWishlistUI
  );

  document.addEventListener(
    'shopify:section:load',
    updateWishlistUI
  );

  window.addEventListener(
    'storage',
    updateWishlistUI
  );

  updateWishlistUI();
})();